import type { ReactNode } from "react";
import { RefreshCw } from "lucide-react";
import { cn } from "@/lib/utils";

// Единый вид ошибки загрузки/действия: одна строка розовым, опционально
// кнопка «Повторить». Принимает Error/строку (`error`) или свой текст (children).

export function ErrorNote({
  error,
  children,
  onRetry,
  className,
}: {
  error?: unknown;
  children?: ReactNode;
  onRetry?: () => void;
  className?: string;
}) {
  const text =
    children ??
    (error instanceof Error
      ? error.message
      : typeof error === "string"
        ? error
        : "Не удалось загрузить данные.");
  return (
    <div
      role="alert"
      className={cn(
        "flex items-center gap-3 text-sm text-rose-600 dark:text-rose-400",
        className,
      )}
    >
      <span>{text}</span>
      {onRetry && (
        <button type="button" className="btn btn-sm" onClick={onRetry}>
          <RefreshCw className="h-3.5 w-3.5" />
          Повторить
        </button>
      )}
    </div>
  );
}

export default ErrorNote;
